import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "./JsonMapper";
import { serializeObject } from "../../mcn-helpers";
import JsonMapperModuleResolver from "./JsonMapperModuleResolver";
export default class JsonArrayMapper extends Array {
  constructor(items, Model) {
    items = Array.isArray(items) ? items : [];
    let list = items.map(item => {
      let ItemModel = Model;
      if (Model === JsonMapperModuleResolver || JsonMapperModuleResolver.isPrototypeOf(Model)) {
        ItemModel = Model.getResolvedModule(item);
      }
      return JsonMapper.isPrototypeOf(ItemModel) ? new ItemModel(item) : serializeObject(item, ItemModel);
    });
    super(...list);
  }
}